<template>
    <svg viewBox="0 0 24 24"><circle r="3.75" cy="12" cx="12" fill="currentColor" /></svg>
</template>
